/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type UpdateProgramMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  programInput: Types.Programs_Set_Input;
}>;

export type UpdateProgramMutation = {
  __typename?: 'mutation_root';
  update_programs_by_pk?: { __typename?: 'programs'; id: string } | null;
};

export const UpdateProgramDocument = `
    mutation UpdateProgram($id: uuid!, $programInput: programs_set_input!) {
  update_programs_by_pk(pk_columns: {id: $id}, _set: $programInput) {
    id
  }
}
    ` as string & TypedDocumentNode<UpdateProgramMutation, UpdateProgramMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    UpdateProgram: build.mutation<UpdateProgramMutation, UpdateProgramMutationVariables>({
      query: (variables) => ({ document: UpdateProgramDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpdateProgramMutation } = injectedRtkApi;
